<template>
    <div id="lrbg_layout">
        <div :class="['lrbg_aside', site_skin]">
            <div class="aside_logo">
                <img class="logo_img" :src="'/static/skin/'+site_skin+'/logo2.png'" alt="" srcset="">
            </div>
            <div class="aside_nav">
                <router-link  :class="['nav_item',{'active':$route.path=='/chat'&&$route.fullPath.indexOf('Chat4.0')==-1}]" exact to="/chat"><div class="nav_content"><img class="nav_icon" :src="'/static/skin/'+site_skin+'/gpt3.5.png'">Chat3.5<img v-if="site_free==1" class="free_tag" src="./img/free.gif"></div></router-link>
                <router-link active-class="active" class="nav_item" to="/chat?model=Chat4.0"><div class="nav_content" @click="changeNav"><img class="nav_icon" :src="'/static/skin/'+site_skin+'/gpt4.0.png'">Chat4.0</div></router-link>
                <router-link active-class="active" class="nav_item" to="/draw"><div class="nav_content"><img class="nav_icon" :src="'/static/skin/'+site_skin+'/mj.png'">MJ绘画</div></router-link>
                <router-link active-class="active" class="nav_item" to="/create"><div class="nav_content" style="padding-right: 8px;"><img class="nav_icon" :src="'/static/skin/'+site_skin+'/create.png'">AI写作</div></router-link>
            </div>
            <div class="aside_tool">
                <div class="slide_btn_group">
                    <div class="slide_btn" @click="showVip(3)">
                        <img class="slide_btn_icon" :src="'/static/skin/'+site_skin+'/mjvip.png'" />
                        <div class="slide_btn_text">绘画会员</div>
                    </div>
                    <div class="slide_btn" @click="showVip(2)">
                        <img class="slide_btn_icon" :src="'/static/skin/'+site_skin+'/gpt4vip.png'" />
                        <div class="slide_btn_text">4.0字数包</div>
                    </div>
                    <div class="slide_btn" @click="showVip(1)">
                        <img class="slide_btn_icon" :src="'/static/skin/'+site_skin+'/is_vip.png'" />
                        <div class="slide_btn_text">问答会员</div>
                    </div>
                    <div class="slide_btn">
                        <img class="slide_btn_icon" :src="'/static/skin/'+site_skin+'/service_new.png'" />
                        <div class="slide_btn_text">在线客服</div>
                        <div class="gzh_wrapper">
                            <div class="gzh_panel">
                                <div class="login_title">早8:30 - 下午18:00(其他时间请留言)</div>
                                <div class="code_img"><img class="gzh_code" src="./img/gzh_code.png" alt=""></div>
                                <div class="cover_label">扫码关注公众号进行咨询</div>
                            </div>
                        </div>
                    </div>
                    <!-- <div class="slide_btn" @click="showPcDesk()">
                        <img class="slide_btn_icon" src="./img/pc.png" />
                        <div class="slide_btn_text">PC客户端</div>
                    </div> -->
                </div>
                <div class="user_info">
                    <img class="avatar" :src="userInfo.avatarurl || df_avatar" >
                    <div class="user_info_right">
                        <div class="user_name" @click="checkLogin" v-if="!isLogin">未登录，点此登录</div>
                        <template v-else>
                            <div class="user_name"><span class="name_text">{{ userInfo.nickname ? userInfo.nickname : "微信用户" }}</span><span :class="['vip_icon',site_skin,userInfo.is_vip?'is_vip':'no_vip']"></span></div>
                            <div class="user_desc" v-if="userInfo.uid">ID：{{userInfo.uid}}</div>
                        </template>
                    </div>
                    <div class="user_wrapper" v-if="isLogin">
                        <div class="user_panel">
                            <div class="panel_top">
                                <img class="avatar" :src="userInfo.avatarurl || df_avatar" >
                                <div class="user_info_right">
                                    <div class="user_name">{{ userInfo.nickname ? userInfo.nickname : "微信用户" }}<span :class="['vip_icon', site_skin, userInfo.is_vip?'is_vip':'no_vip']"></span></div>
                                    <div class="user_desc" v-if="userInfo.uid">ID：{{userInfo.uid}}</div>
                                </div>
                                <img src="./img/exit.png" class="exit_icon" @click="logout" />
                            </div>
                            <div class="panel_content">
                                <div class="content_line">
                                    <div class="line_title" v-if="userInfo.is_vip==1">Chat3.5会员到期时间：{{ userInfo.vip_end_date }}</div>
                                    <div class="line_title" v-else>Chat3.5开通会员可获得以下权限</div>
                                    <div class="line_btn"><span class="btn_ele"  @click="showVip(1)">升级</span></div>
                                </div>
                                <div class="content_line">
                                    <div class="line_title" v-if="userInfo.draw_is_vip==1">MJ会员到期时间：{{ userInfo.draw_vip_end_date }}</div>
                                    <div class="line_title" v-else>MJ开通会员可获得以下权限</div>
                                    <div class="line_btn"><span class="btn_ele"  @click="showVip(3)">升级</span></div>
                                </div>
                                <div class="content_line">
                                    <div class="line_title">Chat4.0剩余字数：{{userInfo.word_balance}}字</div>
                                    <div class="line_btn"><span class="btn_ele"></span><span class="btn_ele" @click="showVip(2)">购买</span></div>
                                </div>
                                <ul class="advantage clearfix">
                                    <li v-for="(ad,index) in advantages" :key="index"><img class="advantage_icon" src="./img/advantage.png" alt="">{{ ad }}</li>
                                </ul>
                                <div class="panel_tips"><img class="tips_icon" src="./img/tips.png" alt="">由于政策原因，我们不保存您任何提问，请自行及时储存！</div>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
        </div>
        <div class="lrbg_container">
            <router-view></router-view>
        </div>
        <vippanel v-if="showVipPopup" :type="openType" :from="0" :showPopup.sync="showVipPopup" @confirm="vipPopupConfirm"></vippanel>
        <updatepanel ref="updatepanel" :from="1" @update="vipUpdate"></updatepanel>
        <deskapppanel ref="deskapp"></deskapppanel>
    </div>
</template>
<script type="text/ecmascript-6">
    import vippanel from "COMPONENTS/VipPanel.vue"
    import updatepanel from "COMPONENTS/UpdatePanel.vue"
    import deskapppanel from "COMPONENTS/DeskAppPanel.vue"
    export default {
        components:{vippanel,updatepanel,deskapppanel},
        data() {
            return {
                df_avatar:require("./img/df_avatar.png"),
                showVipPopup:false,
                advantages:["不限制提问次数","可使用4.0版本","无需魔法上网","优先测试新功能","免费使用提问工具","客服一对一解决问题"],
                openType:1,
                site_free:0,
                site_skin:''
            }
        },
        created() {
            let skin = this.$route.query.skin || '';
            if(skin){
                SiteSkin = skin
                APP_ID = Skin_APP_ID
                SiteTitle = Skin_SiteTitle
                MAIN_URLROOT = Skin_MAIN_URLROOT
            }
            this.site_skin = SiteSkin
            this.site_free = SiteFree;
        },
        computed:{
            userInfo(){
                return this.$store.state.userInfo;
            },
            isLogin(){
                return this.$store.state.isLogin;
            }
        },
        methods: {
            showPcDesk(){
                this.$refs.deskapp.show();//安装桌面应用弹窗
            },
            showVip(type){
                if(!this.isLogin){
                    this.$showLogin();
                    return;
                }
                if(type == 2){
                    if(this.userInfo.is_vip==0){
                        // this.$toast("4.0字数包仅支持会员购买");
                        this.$refs.updatepanel.show();
                        return;
                    }
                }
                this.openType = type;
                this.showVipPopup = true;
                
                //埋点
                let user_id = this.userInfo.uid
                zjzBrowseRecord({user_id:user_id, mod_code:"p004"})
            },
            vipPopupConfirm(){
                let invite_code = localStorage.getItem("invite_code")||"";
                this.$http.get('/front/my/profile/?invite_code='+ invite_code+'&app_id='+APP_ID).then(res =>{
                    if(res.status=='200'){
						this.$store.commit("setUserInfo",res.data);
                    }else{
                        this.$toast(res.message)
                    }
                })
            },
            checkLogin(){
                // 检查登录状态
                if(!this.isLogin){
                    this.$showLogin();
                    return;
                }
            },
            changeNav(e){
                if(this.userInfo.is_vip==0){
                    e.preventDefault();
                    this.$refs.updatepanel.show();
                }
            },
            vipUpdate(from){
                console.log("组件传来的值："+from);
                this.showVip(1)
            },
            logout(){
                if(confirm("确定要退出当前账号？")){
                    this.$store.commit("setIsLogin",false);
					this.$store.commit("setUserInfo",{});
                    localStorage.clear();
                    location.replace("/chat")
                }
            },
        },
    };
</script>
<style rel="stylesheet/scss" lang="scss" scoped>
    #lrbg_layout{
        display: flex;
        width: 100vw;
        height: 100vh;
        min-width: 1300px;
        min-height: 600px;
        background-color: #fff;
        overflow: hidden;
        .lrbg_aside{
            width: 140px;
            flex-shrink: 0;
            background-color: #18a058;
            padding: 20px 0 6px;
            display: flex;
            flex-direction: column;
            .aside_logo{
                width: 40px;
                margin: 0 auto 20px;
                .logo_img{
                    display: block;
                    width: 100%;
                }
            }
            .aside_nav{
                overflow-y: scroll;
                margin-right: -17px;
                padding-left: 10px;
                flex-grow: 1;
                .nav_item{
                    display: block;
                    margin-right: 15px;
                    height: 45px;
                    color: #18a058;
                    margin-bottom: 20px;
                    border-radius: 3px;
                    background-color: #cbf8e0;
                    font-size: 15px;
                    &.active{
                        margin-right: 0;
                        background-color: #fff;
                        border-top-right-radius: 0;
                        border-top-left-radius: 0;
                        padding-right: 15px;
                    }
                    .nav_content{
                        width: 100%;
                        height: 100%;
                        display: flex;
                        align-items: center;
                        justify-content: center;
                        position: relative;
                        .free_tag{
                            position: absolute;
                            top: 16px;
                            right: -8px;
                        }
                    }
                    .nav_icon{
                        width: 18px;
                        margin-right: 10px;
                    }
                }
            }
            .aside_tool{
                padding: 0 5px;
                .slide_btn_group{
                    padding: 0 7px;
                    .slide_btn{
                        background-color: #cbf8e0;
                        border-radius: 3px;
                        height: 40px;
                        display: flex;
                        align-items: center;
                        justify-content: center;
                        color: #18a058;
                        margin-bottom: 20px;
                        font-size: 15px;
                        position: relative;
                        cursor: pointer;
                        .slide_btn_icon{
                            margin-right: 10px;
                            display: block;
                            width: 16px;
                            height: 16px;
                        }
                        &:hover{
                            .gzh_wrapper{
                                display: block;
                            }
                        }
                        .gzh_wrapper{
                            position: absolute;
                            z-index: 30;
                            bottom: 0;
                            right: -286px;
                            padding-left: 26px;
                            display: none;
                            .gzh_panel{
                                width: 260px;
                                background-color: #fff;
                                padding: 12px;
                                box-shadow: 0 0 10px 4px #ccc;
                                border-radius: 6px;
                                .login_title{
                                    color: #000;
                                    font-size: 14px;
                                    font-weight: 700;
                                    text-align: center;
                                }
                                .code_img{
                                    width: 100%;
                                    img{
                                        display: block;
                                        width: 100%;
                                        height: 100%;
                                    }
                                }
                                .cover_label{
                                    text-align: center;
                                    padding-bottom: 6px;
                                    color: #9a9a9a;
                                    font-size: 12px;
                                }
                            }
                        }
                    }
                }
                .user_info{
                    height: 50px;
                    display: flex;
                    align-items: center;
                    cursor: pointer;
                    padding: 0 7px;
                    background-color: #fff;
                    border-radius: 4px;
                    position: relative;
                    &:hover{
                        .user_wrapper{
                            display: block;
                        }
                    }
                    .avatar{
                        width: 30px;
                        height: 30px;
                        background-size: 100% 100%;
                        flex-shrink: 0;
                        cursor: pointer;
                        border-radius: 50%;
                        margin-right: 10px;
                    }
                    .user_info_right{
                        flex-grow: 1;
                        overflow: hidden;
                        .user_name{
                            font-weight: bold;
                            display: flex;
                            .name_text{
                                white-space: nowrap;
                                text-overflow: ellipsis;
                                display: block;
                                overflow: hidden;
                            }
                            .vip_icon{
                                background-color: #fff;
                                display: block;
                                flex-shrink: 0;
                                width: 14px;
                                height: 14px;
                                background-size: 100% 100%;
                                vertical-align: middle;
                                margin-top: -2px;
                                margin-left: 8px;
                                &.is_vip{
                                    background-image: url("./img/is_vip.png");
                                }
                                &.no_vip{
                                    background-image: url("./img/no_vip.png");
                                }
                            }
                            .black{
                                display: block;
                                flex-shrink: 0;
                                width: 14px;
                                height: 14px;
                                background-size: 100% 100%;
                                vertical-align: middle;
                                margin-top: -2px;
                                margin-left: 8px;
                                &.is_vip{
                                    background-image: url("/static/skin/black/is_vip.png");
                                    // background-image: url("./img/is_vip.png");
                                }
                                &.no_vip{
                                    background-image: url("./img/no_vip.png");
                                }
                            }
                        }
                        .user_desc{
                            color: #999;
                            font-size: 11px;
                        }
                    }
                    .user_wrapper{
                        position: absolute;
                        z-index: 30;
                        bottom: 0;
                        right: -470px;
                        padding-left: 20px;
                        display: none;
                        cursor: initial;
                        .user_panel{
                            width: 450px;
                            background-color: #fff;
                            padding: 6px 32px;
                            box-shadow: 0 0 10px 4px #ccc;
                            border-radius: 6px;
                            .panel_top{
                                height: 82px;
                                display: flex;
                                align-items: center;
                                border-bottom: 1px dashed #ccc;
                                .exit_icon{
                                    display: block;
                                    width: 16px;
                                    cursor: pointer;
                                }
                            }
                            .panel_content{
                                padding: 10px 0 7px;
                                .content_line{
                                    display: flex;
                                    font-size: 12px;
                                    line-height: 40px;
                                    .line_title{
                                        color: #18a058;
                                        flex-grow: 1;
                                        font-weight: bold;
                                    }
                                    .line_btn{
                                        .btn_ele{
                                            cursor: pointer;
                                            text-decoration: underline;
                                            margin-left: 16px;
                                            &:hover{
                                                color: #18a058;
                                            }
                                        }
                                    }
                                }
                                .advantage{
                                    padding: 0 4px;
                                    li{
                                        font-size: 12px;
                                        color: #999;
                                        float: left;
                                        line-height: 38px;
                                        width: 50%;
                                        &:nth-of-type(even){
                                            padding-left: 36px;
                                        }
                                        .advantage_icon{
                                            width: 16px;
                                            height: 16px;
                                            vertical-align: middle;
                                            margin: -3px 9px 0 0;
                                        }
                                    }
                                }
                                .panel_tips{
                                    font-size: 12px;
                                    color: #fab935;
                                    line-height: 46px;
                                    text-align: center;
                                    .tips_icon{
                                        width: 16px;
                                        height: 16px;
                                        vertical-align: middle;
                                        margin: -3px 12px 0 0;
                                    }
                                }
                            }
                        }
                    }
                }
            }
            //
            
        }
        .lrbg_container{
            flex-grow: 1;
        }
        .black{
            background-color: #000;
            .aside_nav{
                .nav_item{
                    color: #000;
                    background-color: #ccc;
                    &.active{
                        background-color: #fff;
                    }
                }
            }
            .aside_tool{
                .slide_btn_group{
                    .slide_btn{
                        background-color: #ccc;
                        color: #000;
                    }
                }
            }
            //
            
        }
    }
</style>